import React from 'react';

import { FormattedMessage } from 'react-intl';

import { ErrorMessage } from '@atlaskit/form/error-message';
import { ValidMessage } from '@atlaskit/form/valid-message';

import { convertLegacyColor } from '../../../common/utils';

import { messages } from './messages';

type ColorValidationMessagesProps = {
	isReadableColor?: (color: string) => boolean;
	preSelectedColor?: string;
	selectedColor: string;
	showConfirmation: boolean;
	validationFailMessage?: string;
	validationSuccessMessage?: string;
};

export const ColorValidationMessages = ({
	selectedColor,
	isReadableColor,
	showConfirmation,
	preSelectedColor,
	validationFailMessage,
	validationSuccessMessage,
}: ColorValidationMessagesProps): React.JSX.Element | null => {
	const convertedColor = convertLegacyColor(selectedColor);
	const isInvalid = !convertedColor.isValid();

	if (isInvalid || !preSelectedColor) {
		return (
			<ErrorMessage>
				<FormattedMessage {...messages.errorMessage} />
			</ErrorMessage>
		);
	}

	if (showConfirmation) {
		return (
			<ValidMessage>
				<FormattedMessage {...messages.confirmationMessage} />
			</ValidMessage>
		);
	}

	if (isReadableColor) {
		if (isReadableColor(selectedColor)) {
			return (
				<ValidMessage>
					{validationSuccessMessage || <FormattedMessage {...messages.contrastRatioPassMessage} />}
				</ValidMessage>
			);
		}
		return (
			<ErrorMessage>
				{validationFailMessage || <FormattedMessage {...messages.contrastRatioFailMessage} />}
			</ErrorMessage>
		);
	}

	return null;
};
